<ng-template appPlaceholder></ng-template>
<app-modal
  [visible]="isVisible"
  [usePadding]="false"
  class="activity-log-modal"
  >
  <div class="activity-log-modal-content flex">
    <div
      class="flex__column profile-details activity-log-column"
      [ngClass]="{ 'profile-details-only': !connection?.connection_name }"
      >
      <div class="profile-header flex__row--space-between">
        <img
          src="assets/icons/x-close-black.svg"
          class="_close-icon"
          alt="close-icon"
          (click)="onClose()"
          />
        <a
          rel="noreferrer"
          target="_blank"
          href="{{ connection?.profile_link || connection?.profile_url }}"
          class="cta-link"
          title="View Linkedin Profile"
          >
          <img src="assets/icons/linkedin-icon.svg" class="linkedin-icon" />
        </a>
      </div>
      <div class="profile-card-wrapper flex__center fx-1">
        <profile-vertical-card
          [image]="connection?.image_url"
          [profileUrl]="connection?.profile_link || connection?.profile_url"
          [fullName]="connection?.connection_name || connection?.lead_name"
          [jobTitle]="connection?.job_title"
          [connectedOn]="
            connection?.connected_on_date && connection?.connected_on_date
              | dateAgo
          "
          [email]="connection?.email"
          [phone]="connection?.phone_number"
          [location]="connection?.location"
          [company]="connection?.company_name"
        ></profile-vertical-card>
      </div>
      <div class="activity-log-actions flex__column--space-between fx-1">
        <div class="activity-actions">
          @if (
            connection?.stage !== 'resolved' && connection?.connection_name
            ) {
            <app-button
              class="outlined"
              [fullWidth]="true"
              label="Mark as complete"
              (click)="showPrompt('complete')"
            ></app-button>
          }
          @if (
            connection?.stage === 'resolved' && connection?.connection_name
            ) {
            <app-button
              class="outlined"
              [fullWidth]="true"
              label="Mark as active"
              (click)="showPrompt('active')"
            ></app-button>
          }
          @if (connection?.profile_urn) {
            <app-button
              [class]="isSendMessageActive ? 'primary' : 'outlined'"
              [fullWidth]="true"
              label="Send Message"
              (click)="onToggleMessageInput()"
              style="margin-top: 10px"
            ></app-button>
          }
          @if (connection?.lead_name) {
            <app-button
              class="danger"
              [fullWidth]="true"
              label="Delete lead"
              (click)="showPrompt('delete')"
              style="margin-top: 10px"
            ></app-button>
          }
        </div>
        <div class="activity-input-wrapper">
          @if (isSendMessageActive) {
            <div class="input-wrapper">
              <app-text-area
                (input)="onSendMessageChange($event)"
                [value]="message"
                label="Send message"
              ></app-text-area>
              <app-button
                class="secondary send-btn flex__row--end"
                label="Send"
                [fullWidth]="true"
                loadingLabel="Sending"
                [isLoading]="isLoadingMessageSend"
                [disabled]="!message.length || isLoadingMessageSend"
                (click)="onSendMessageClick()"
              ></app-button>
            </div>
          }
        </div>
      </div>
    </div>
    @if (connection?.connection_name) {
      <div
        class="flex__column activity-details activity-log-column"
        >
        <div class="tabs flex">
          <div class="tab-control flex__column">
            <app-button
              [class.active]="activeTab === 'activity'"
              class="text"
              (click)="setActiveTab('activity')"
              label="Activity"
              >
            </app-button>
            <div
              class="active-tab-indicator"
              [ngClass]="{ 'active-tab': activeTab === 'activity' }"
            ></div>
          </div>
          <div class="tab-control flex__column">
            <app-button
              [class.active]="activeTab === 'messages'"
              class="text"
              (click)="setActiveTab('messages')"
              label="Messages"
              >
            </app-button>
            <div
              class="active-tab-indicator"
              [ngClass]="{ 'active-tab': activeTab === 'messages' }"
            ></div>
          </div>
        </div>
        @if (activeTab === 'messages') {
          <div
            class="messages-log _easeTopToBottom"
            >
            <ng-container
          *skeleton="
            isLoadingMessages;
            repeat: 10;
            className: '__mb-2';
            height: '50px';
            width: '100%';
            borderRadius: '10px'
          "
              >
              @for (message of messages; track message) {
                <app-message-cell
            [message]="
              message?.message || message?.message_content || 'Message deleted'
            "
                  variant="primary"
            [senderName]="
              message?.firstName
                ? message.firstName + ' ' + message.lastName
                : message?.sender || 'Unknown sender'
            "
            [senderImage]="
              message?.sender_id === connection?.profile_urn
                ? connection?.image_url
                : userProfileImage
            "
                  [dateTime]="message.sent_time"
                ></app-message-cell>
              }
            </ng-container>
            @if (!messages?.length && !isLoadingMessages) {
              <div>
                No messages found.
              </div>
            }
          </div>
        }
        @if (activeTab === 'activity') {
          <div class="activity-log">
            <!-- <h4>Activity</h4> -->
            <ng-container
          *skeleton="
            isLoading;
            repeat: 10;
            className: '__mb-2';
            height: '70px';
            width: '100%';
            borderRadius: '10px'
          "
              >
              @for (activity of activityData; track activity) {
                <activity-log-cell
                  [activityType]="activity?.activityType"
                  [activityDescription]="activity?.message"
                  [icon]="activity?.icon"
                  [dateTime]="activity?.createdAt | date : 'MMMM d, y h:mm a'"
                ></activity-log-cell>
              }
            </ng-container>
            @if (!activityData?.length && !isLoading) {
              <div>
                <activity-log-cell
                  [activityDescription]="'Sent invitation to connect'"
                  [icon]="'assets/icons/send-check.svg'"
                  [dateTime]="connection?.created_at | dateAgo"
                ></activity-log-cell>
                <activity-log-cell
            [activityDescription]="
              'Prospect accepted your invitation to connect'
            "
                  [icon]="'assets/icons/link.svg'"
                  [dateTime]="connection?.connected_on_date"
                ></activity-log-cell>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</app-modal>
